module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fa":{"We are updating and will be back soon and wait until then.":"در حال بروزرسانی هستیم و به زودی باز میگردیم و تا آن موقع منتظر بمانید.","Under Maintenance!":"در حال تعمیر و بروزرسانی!","Back to Home":"صفحه اصلی"}}')
  delete Component.options._Ctor
}
